// Marca Bestigium: monumento estilizado + chincheta (coherente con el favicon de la app).
export function Logo({ className = '', withText = true }: { className?: string; withText?: boolean }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg viewBox="0 0 100 100" className="h-8 w-8 shrink-0" aria-hidden="true">
        <rect width="100" height="100" rx="22" fill="#92400e" />
        <path
          d="M20 70 L50 20 L80 70"
          stroke="#fbbf24"
          strokeWidth="8"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="50" cy="50" r="8" fill="#fbbf24" />
        <line x1="50" y1="58" x2="50" y2="75" stroke="#fbbf24" strokeWidth="6" strokeLinecap="round" />
      </svg>
      {withText && (
        <span className="font-display text-xl font-semibold tracking-tight text-clay-50">Bestigium</span>
      )}
    </span>
  );
}
